<script setup lang="ts">
import { vIntersectionObserver } from "@vueuse/components";
import { computed, ref } from "vue";

interface Props {
  color?: "primary" | "accent";
}

const props = withDefaults(defineProps<Props>(), { color: "accent" });

const COMPONENT_CLASS = "le-heading-highlight";

const componentClasses = computed(() => [
  COMPONENT_CLASS,
  { [`${COMPONENT_CLASS}--color-${props.color}`]: isVisible.value }
]);

const root = ref(null);

const isVisible = ref(false);

function onIntersectionObserver([entry]: IntersectionObserverEntry[]) {
  if (isVisible.value) {
    return;
  }

  isVisible.value = entry.isIntersecting;
}
</script>

<template>
  <span ref="root" v-intersection-observer="[onIntersectionObserver, { root }]" :class="componentClasses">
    <slot></slot>
  </span>
</template>

<style lang="less">
@import "@dsk/styles/all";

@color-map: {
  @primary: {
    background: @colors[@primary][800];
    color: @colors[@neutrals][100];
  };
  @accent: {
    background: @colors[@accent][400];
    color: @colors[@neutrals][400];
  };
};

.le-heading-highlight {
  each(@color-map, {
    @color: replace(@key, "@", "");

    &--color-@{color} {
    display: inline-block; // Avoid breaking where there is a snippet of highlight in the previous line
    -webkit-animation: highlight 1s 1 normal forwards;
    animation: highlight 1s 1 normal forwards;
    background: linear-gradient(90deg, @value[background] 50%, rgba(255, 255, 255, 0) 50%);
    background-color: none;
    background-position: 100% 0;
    background-size: 200% 100%;
    color: @value[color];
    padding: 4px;
    margin: -4px;
    }
  });
}

@keyframes highlight {
  to {
    background-position: 0 0;
  }
}
</style>
